import { useEffect } from 'react';

export function useAutoPlayVideo(videoRefs: React.RefObject<HTMLVideoElement>[]) {
  useEffect(() => {
    const playVideo = (video: HTMLVideoElement) => {
      if ((video.paused || video.ended) && document.visibilityState === 'visible') {
        video.loop = true;
        video.play().catch(error => {
        });
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        videoRefs.forEach((videoRef) => {
          const video = videoRef.current;
          if (video) {
            playVideo(video);
          }
        });
      }
      else {
        videoRefs.forEach((videoRef) => {
          const video = videoRef.current;
          if (video) {
            video.pause();
          }
        });
      }
    };

    const handleUnload = () => {
      videoRefs.forEach((ref) => {
        if (ref.current) {
          ref.current.pause();
          ref.current.src = '';
          ref.current.load();
        }
      });
    };


    videoRefs.forEach(videoRef => {
      const video = videoRef.current;
      if (!video) return;

      // Initial play
      playVideo(video);

      // Add listeners once
      const onPauseOrEnd = () => playVideo(video);
      video.addEventListener('pause', onPauseOrEnd);
      video.addEventListener('ended', onPauseOrEnd);

      // Save to video element for cleanup
      (video as any)._onPauseOrEnd = onPauseOrEnd;
    });

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener("unload", handleUnload);

    return () => {
      videoRefs.forEach(videoRef => {
        const video = videoRef.current;
        if (video && (video as any)._onPauseOrEnd) {
          video.removeEventListener('pause', (video as any)._onPauseOrEnd);
          video.removeEventListener('ended', (video as any)._onPauseOrEnd);
          delete (video as any)._onPauseOrEnd;
        }
      });
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('unload', handleUnload)
    };
  }, [videoRefs]);
}
